export default {
  name: "NotFound"
};